// extracted by mini-css-extract-plugin
export default {"signInAlert":"Tc"};